<ngb-datepicker
  [navigation]="'arrows'"
  [minDate]="minAsNgbDate"
  [maxDate]="maxAsNgbDate"
  [markDisabled]="isDateDisabled"
  [outsideDays]="'hidden'"
  [dayTemplate]="dayTemplate"
  [footerTemplate]="footerTemplate"
  [startDate]="startDate"
  (dateSelect)="onDateSelection($event)"
></ngb-datepicker>

<ng-template #dayTemplate let-date let-focused="focused">
  <span
    class="day"
    [ngClass]="{
      focused: focused,
      selected: isDateSelected(date),
      first: isDateSelectedFrom(date),
      range: isDateWithinSelection(date)
    }"
    (mouseenter)="onDateMouseEnter(date)"
    (mouseleave)="onDateMouseLeave()"
  >
    {{ date.day }}
  </span>
</ng-template>

<ng-template #footerTemplate>
  <footer>
    <ng-content></ng-content>
  </footer>
</ng-template>
